import { render, staticRenderFns } from "./CoozzySidebarNavLink.vue?vue&type=template&id=77cb24d5&scoped=true"
import script from "./CoozzySidebarNavLink.vue?vue&type=script&lang=js"
export * from "./CoozzySidebarNavLink.vue?vue&type=script&lang=js"
import style0 from "./CoozzySidebarNavLink.vue?vue&type=style&index=0&id=77cb24d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cb24d5",
  null
  
)

export default component.exports